// Статистика
import { Card } from 'antd';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { useStatistics } from 'hooks';
import Loader from 'components/Common/Loader';

ChartJS.register(ArcElement, Tooltip, Legend);

const Statistics = () => {
	document.title = "Статистика";
	const { data, loading } = useStatistics();

	return (
		<div className="page-content">
			<div className="container-fluid">
				<Card>
					{loading && <Loader />}
					{!loading && (
						<div style={{ height: '80vh', width: '100%' }}>
							<Pie data={data} />
						</div>
					)}
				</Card>
			</div>
		</div>
	)
}


export default Statistics;